//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ColoredStoneTypeToggle',
  props: {
    control: {required: true},
    data: {required: true},
    product: {required: true},
    stonePositions: {required: false},
  },
  computed: {
    coloredStoneType() {
      return this.product.ColoredStoneType
    },
  },
  methods: {
    coloredStoneTypeChanged: function coloredStoneTypeChanged(v) {
      const selectedColoredStoneType = v.split('_')[0]
      this.$emit('updateValue', {
        controlType: this.control.type,
        controlName: this.control.name,
        value: selectedColoredStoneType,
      })
    },
  },
}
